import { useEffect, useLayoutEffect, useState } from "react";
import { connect, useStore } from "react-redux";
import { useHistory } from "react-router-dom";
import useMedia from "use-media";
import { useRtoaster } from "../../../hooks/useRtoaster";
import commonUtil from "../../../common/commonUtil";
import { apiKeyCheck, getAvailablePlan, versionGetApi } from "../../../const";
import Const from "../../../const/Const";
import messageConst from "../../../const/messageConst";
import common from "../../../resources/js/common/common";
import '../../../resources_membership_hotel/css/hotel/changePlan.css';
import { Button } from "../../atoms/button";
import { BreadCrumb } from '../../molecules/breadCrumb';
import ConditionChangeArea from "../../molecules/conditionChangeArea";
import { ErrorMassage } from "../../molecules/errorMassage";
import { PlanList } from "../../molecules/planList";

const MembershipChangePlanContainer = (props) => {
    const {
        login,
        room,
        adultNum,
        childNum,
        planConditions,
        grade,
        food,
        privilegedService,
        setDispDetailCondition,
        setRoom,
        setAdultNum,
        setChildNum,
        setPlanConditions,
        setGrade,
        setFood,
        setPopupData,
        setPrivilegedService,
        membershipSearchParam,
        setMembershipSearchParam,
        membershipReserveInfo,
        setMembershipReserveInfo,
        setInputUserInfo,
        setRight,
        onClickOpenCalendarWindow,
        onClickOpenCheckListWindow,
        membershipReserveComf,
        setMembershipResvStartDate,
        resvKaiinken,
        inputUserInfo } = props;

    const loginType = login.loginType;

    //レスポンシブ対応
    const isWidePhone = useMedia({ maxWidth: '480px' });
    const isWideTablet = useMedia({ maxWidth: '960px' });
    const [Phone, setPhone] = useState(false);
    const [Tablet, setTablet] = useState(false);
    const useMediaFlag = useMedia({ maxWidth: '480px' });
    const [isMobilePhone, setIsMobilePhone] = useState(false);
    const [displaySwitch, setDisplaySwitch] = useState(false);
    const history = useHistory();
    const store = useStore();

    const [linkList, setLinkList] = useState([]);
    const [kaiinkenInfo, setKaiinkenInfo] = useState({ keiyakuNo: "", kaiinkenCd: "", kaiinkenNo: "", riyoKaiinkenSyubetCd: "" });

    // プラン一覧
    const [facilityList, setFacilityList] = useState([]);
    const [planNum, setPlanNum] = useState(0);

    const [dateList, setDateList] = useState(0);

    // エラー情報
    const [errorInfo, setErrorInfo] = useState({ errorMessage: null, errorFlg: false, });
    const [errFlgList, setErrFlgList] = useState({ errPeopleNum: false, errAdultNum: false });

    // rtoasterタグ生成
    const customParam = {
        "riyosyodat": membershipReserveComf.checkInDate,
        "sisetucd": membershipReserveComf.shisetsuCd,
        "packcd": membershipReserveComf.planCd ? membershipReserveComf.planCd : "",
        "packnam": membershipReserveComf.planName ? membershipReserveComf.planName : "",
        "keiyakuno": membershipReserveComf.keiyakuNo,
        "roomsu": membershipReserveComf.roomList.length,
        "hakusu": membershipReserveComf.hakuCnt,
    }
    useRtoaster(history.location.pathname, customParam);

    useLayoutEffect(() => {
        // リフレッシュ対応
        let state = store.getState().login;
        let apiKey = null;
        if (Object.keys(state).length !== 0) {
            apiKey = state.apiKey;
        }
        if (apiKey === null) {
            store.dispatch({ type: "CLEAR_STATE" });
            history.push("/reserve/login");
        }
        if (apiKey) {
            common.doPost(apiKeyCheck, { apikey: apiKey }, afterApiKeyCheck);
        }
    })
    const afterApiKeyCheck = (res) => {
        if (!res.data) {
            console.log("バックからの戻り値false");
            store.dispatch({ type: "CLEAR_STATE" });
            history.push("/reserve/login");
        }
    }

    useEffect(() => {
        if (useMediaFlag) {
            setIsMobilePhone(true);

        } else {
            setIsMobilePhone(false);
        }
    }, [useMediaFlag]);

    // API呼出等事前処理
    useEffect(() => {
        window.scroll({ top: 0, behavior: 'smooth' })
        common.doPost(versionGetApi, {}, afterVerCheck);

        if (loginType === "MEMBER") {
            setLinkList([
                { path: "/reserve/top", label: "HOME" },
                { path: "/reserve/hotel/search", label: "ホテル予約" },
                { path: "/reserve/hotel/hotelBookingConfirmDetail", label: "予約内容確認" },
            ]);
        } else if (loginType === "CRAWL") {
            setLinkList([
                { path: "/reserve/hotel/crawlSearch", label: "ホテル予約" },
                { path: "/reserve/hotel/hotelBookingConfirmDetail", label: "予約内容確認" },
            ]);
        }

        // チェックアウト日付設定
        let checkOutDates = commonUtil.getDateList(membershipReserveComf.checkInDate, membershipReserveComf.checkOutDate, "yyyy-MM-dd");
        let iniDateList = [];
        checkOutDates.forEach((value, index) => {
            if (index != 0) {
                if (index === checkOutDates.length - 1) {
                    iniDateList.push({ id: value, value: commonUtil.getStringFromDateJpnMembership(value), selected: true });
                } else {
                    iniDateList.push({ id: value, value: commonUtil.getStringFromDateJpnMembership(value), selected: false });
                }
            }
        })
        setDateList(iniDateList.reverse());

        // 詳細条件初期化
        setDispDetailCondition("詳細条件を選択");
        let newPlanConditions = [];
        planConditions.forEach(value => {
            value.checked = false;
            newPlanConditions.push(value);
        })
        setPlanConditions(newPlanConditions);
        let newFood = [];
        food.forEach(value => {
            value.checked = false;
            newFood.push(value);
        })
        setFood(newFood);
        let newPrivilegedService = [];
        privilegedService.forEach(value => {
            value.checked = false;
            newPrivilegedService.push(value);
        })
        setPrivilegedService(newPrivilegedService);
        let newGrade = [];
        grade.forEach(value => {
            value.checked = false;
            newGrade.push(value);
        })
        setGrade(newGrade);

        // 会員権情報設定処理
        let keiyakuNo = "";
        let kaiinkenCd = "";
        let kaiinkenNo = "";
        let riyoKaiinkenSyubetCd = "";
        resvKaiinken.forEach((value) => {
            if (value.keiyakuNo === membershipSearchParam.keiyakuNo && value.riyoKaiinkenSyubetCd === Number(membershipSearchParam.riyoKaiinkenSyubetCd)) {
                keiyakuNo = value.keiyakuNo;
                kaiinkenCd = value.kaiinkenSyubetCd;
                kaiinkenNo = value.value;
                riyoKaiinkenSyubetCd = value.riyoKaiinkenSyubetCd;
            }
        });
        if (loginType === "CRAWL") {
            keiyakuNo = membershipReserveComf.keiyakuNo || "";
            kaiinkenCd = membershipReserveComf.ownerCd || "";
            kaiinkenNo = membershipReserveComf.ownerNo || "";
        }
        if (!riyoKaiinkenSyubetCd) {
            riyoKaiinkenSyubetCd = membershipSearchParam.riyoKaiinkenSyubetCd;
        }
        if (membershipReserveInfo.generalFlg && membershipSearchParam.riyoKaiinkenSyubetCd) {
            // TLの場合は検索条件に契約Noと利用会員種別コードが入っている
            keiyakuNo = membershipSearchParam.keiyakuNo;
            riyoKaiinkenSyubetCd = membershipSearchParam.riyoKaiinkenSyubetCd;
        }
        setKaiinkenInfo({ keiyakuNo: keiyakuNo, kaiinkenCd: kaiinkenCd, kaiinkenNo: kaiinkenNo, riyoKaiinkenSyubetCd: riyoKaiinkenSyubetCd });

        // 室数設定処理
        let rooms = [];
        const roomCnt = Number(membershipReserveComf.roomCnt);
        for (let i = 0; i < roomCnt; i++) {
            if (i === (roomCnt - 1)) {
                rooms.push({ id: (i + 1) + "", value: (i + 1) + "室", selected: true });
            } else {
                rooms.push({ id: (i + 1) + "", value: (i + 1) + "室", selected: false });
            }
        }
        setRoom(rooms);
    }, []);

    const afterVerCheck = (res) => {
        let flg = common.versionCheck(res.data.version);
        if (flg) {
            history.push("/reserve/login");
            return;
        }
    }

    // membershipReserveComf.roomListを指定の長さに減らす（合計人数->大人の人数の順で比較し、少ないものから減らしていく）
    const sliceMembershipReserveComfRoomList = (roomCnt) => {
      const copy = membershipReserveComf.roomList?.slice();
      // 元の並び順を取っておく
      copy.forEach((c, i) => {
        c.prevIndex = i;
      });

      copy.sort((a, b) => {
        const currentAdultSum = a.menCnt + a.womenCnt;
        const currentAllSum = currentAdultSum + a.childCnt;
        const nextAdultSum = b.menCnt + b.womenCnt;
        const nextAllSum = nextAdultSum + b.childCnt;
        // 合計の降順
        if(currentAllSum > nextAllSum) return -1;
        if(currentAllSum < nextAllSum) return 1;
        // 大人の降順
        if(currentAdultSum > nextAdultSum) return -1;
        if(currentAdultSum < nextAdultSum) return 1;
        return 0;
      });

      const result = copy.slice(0, roomCnt);
      // 元の並び順に戻す
      result.sort((a, b) => a.prevIndex - b.prevIndex);
      // prevIndexの削除
      result.forEach(r => {
        delete r.prevIndex;
      })

      return result;
    }

    // 検索ボタン押下時
    const onClickSearch = () => {

        // バリデーションフラグ
        let errFlg = false;
        let errorMessage = [];
        let flgList = { errPeopleNum: false, errAdultNum: false };

        // チェックイン
        const startDate = commonUtil.getStringFromDate(new Date(membershipReserveComf.checkInDate), "yyyy-MM-dd");
        // チェックアウト
        let endDate = "";
        dateList.forEach((data) => {
            if (data.selected === true) endDate = data.id;
        });
        // 室数
        let vacancyNum = 1;
        room.forEach((data) => {
            if (data.selected === true) vacancyNum = parseInt(data.id);
        });

        // 1室あたりの人数
        let adults = 2;
        adultNum.forEach((data) => {
            if (data.selected === true) adults = parseInt(data.id);
        });
        let children = 0;
        childNum.forEach((data) => {
            if (data.selected === true) children = parseInt(data.id);
        });
        if (adults + children > Const.MAX_ROOM_CAPACITY) {
            errorMessage.push(messageConst.PEOPLE_NUM_ERROR);
            errFlg = true;
            flgList.errPeopleNum = true;
        }
        // if (adults < vacancyNum) {
        //     errorMessage.push(messageConst.ADULT_NUM_ERROR);
        //     errFlg = true;
        //     flgList.errAdultNum = true;
        // }

        // グレード
        let gradeArray = [];
        grade.forEach((data) => {
            if (data.checked === true) gradeArray.push(data.id);
        });

        // プラン条件
        let planConditionsArray = [];
        planConditions.forEach((data) => {
            if (data.checked === true) planConditionsArray.push(data.id);
        });

        // 夕食
        let foodArray = [];
        food.forEach((data) => {
            if (data.checked === true) foodArray.push(data.id);
        });

        // サービス権利
        let privilegedServiceArray = [];
        privilegedService.forEach((data) => {
            if (data.checked === true) privilegedServiceArray.push(data.id);
        });

        // リクエスト情報設定
        const req = {
            checkInDate: startDate,
            checkOutDate: endDate,
            shisetsuCdList: [membershipReserveComf.shisetsuCd],
            adultCnt: adults,
            childCnt: children,
            roomCnt: vacancyNum,
            keiyakuNo: kaiinkenInfo.keiyakuNo,
            planConditionsCdList: planConditionsArray,
            roomGradeCdList: gradeArray,
            foodCdList: foodArray,
            privilegedServiceCdList: privilegedServiceArray,
            riyoKaiinkenSyubetCd: kaiinkenInfo.riyoKaiinkenSyubetCd,
            uketsukeDate: membershipReserveComf.uketsukeDate,
        };
        setErrFlgList(flgList);
        if (errFlg) {
            window.scroll({ top: 0, behavior: 'smooth' })
            setErrorInfo({ errorMessage: errorMessage, errorFlg: true, });
        } else {
            setMembershipSearchParam({
                checkInDate: startDate,
                checkOutDate: endDate,
                nights: commonUtil.getNights(startDate, endDate, "-"),
                shisetsuCdList: [membershipReserveComf.shisetsuCd],
                adultCnt: adults,
                childCnt: children,
                roomCnt: vacancyNum,
                keiyakuNo: kaiinkenInfo.keiyakuNo,
                planConditionsCdList: planConditionsArray,
                roomGradeCdList: gradeArray,
                foodCdList: foodArray,
                privilegedServiceCdList: privilegedServiceArray,
                kaiinkenCd: kaiinkenInfo.kaiinkenCd,
                kaiinkenNo: kaiinkenInfo.kaiinkenNo,
                riyoKaiinkenSyubetCd: kaiinkenInfo.riyoKaiinkenSyubetCd,
                memberCd: resvKaiinken.length? resvKaiinken[0].memberCd : "",
            });
            setErrorInfo({ errorMessage: null, errorFlg: false, });
            // プラン検索処理
            common.doPost(getAvailablePlan, req, afterGetAvailablePlan);
            // setFacilityList([
            //     {
            //         shisetsuCd: "101",
            //         shisetsuName: "施設名1",
            //         shisetsuImage: "画像パス",
            //         generalFlg: false,
            //         planShohinList: [
            //             {
            //                 planShohinCd: "001",
            //                 planShohinName: "プラン1",
            //                 planList: [
            //                     {
            //                         planCd: "900",
            //                         planName: "プラン商品名1",
            //                         planDescription: "プラン商品名１のプランです。",
            //                         dinnerTsukiPlanFlg: true,
            //                         breakfastTsukiPlanFlg: true,
            //                         planRyokinTotal: 50000,
            //                         planRyokinAdult: 30000,
            //                         planRyokinChild: 20000,
            //                         thanksFlg: true,
            //                         planTokuten: "プラン特典１",
            //                         planAnnaiUrl: "案内URL(実際はURLパス)",
            //                         machiFlg: "0",
            //                     }
            //                 ]
            //             },
            //             {
            //                 planShohinCd: "002",
            //                 planShohinName: "プラン2",
            //                 planList: [
            //                     {
            //                         planCd: "901",
            //                         planName: "プラン商品名2",
            //                         planDescription: "プラン商品名2のプランです。",
            //                         dinnerTsukiPlanFlg: false,
            //                         breakfastTsukiPlanFlg: false,
            //                         planRyokinTotal: 20000,
            //                         planRyokinAdult: 20000,
            //                         planRyokinChild: 0,
            //                         thanksFlg: false,
            //                         planTokuten: "プラン特典2",
            //                         planAnnaiUrl: "案内URL(実際はURLパス)",
            //                         machiFlg: "1",
            //                     },
            //                     {
            //                         planCd: "902",
            //                         planName: "プラン商品名3",
            //                         planDescription: "プラン商品名３のプランです。",
            //                         dinnerTsukiPlanFlg: true,
            //                         breakfastTsukiPlanFlg: true,
            //                         planRyokinTotal: 40000,
            //                         planRyokinAdult: 30000,
            //                         planRyokinChild: 10000,
            //                         thanksFlg: true,
            //                         planTokuten: "プラン特典３",
            //                         planAnnaiUrl: "案内URL(実際はURLパス)",
            //                         machiFlg: "2",
            //                     }
            //                 ]
            //             }
            //         ]
            //     }
            // ]);
        }
    }
    // 検索後処理
    const afterGetAvailablePlan = (res) => {
        const data = res.data;
        // エラーが発生した場合はメッセージを表示
        let errMsg = null;
        if (data.resultCode != "0") {
            errMsg = messageConst.SEARCH_ERROR;
        }
        if (data.resultCode == "0" && (!data.shisetsuList || !data.shisetsuList.length)) {
            errMsg = messageConst.HOTEL_PLAN_NOT_FOUND_ERROR;
        }
        if (errMsg) {
            window.scroll({ top: 0, behavior: 'smooth' })
            setErrorInfo({ errorMessage: [errMsg], errorFlg: true, });
            setFacilityList([]);
            return;
        }
        // 検索時間設定
        setMembershipResvStartDate(commonUtil.getStringFromDate(new Date(), "yyyy-MM-dd"));
        setFacilityList(data.shisetsuList);
        const selectedRoom = room.find(r => r.selected);
        const roomCnt = selectedRoom ? Number(selectedRoom.id) : 1;
        const inputRooms = sliceMembershipReserveComfRoomList(roomCnt);
        setInputUserInfo({
            ...inputUserInfo,
            inputRoomList: inputRooms.map((r) => {
                return {
                    ...r,
                    roomTypeName: r.hyjRmType,
                };
            }),
        });
    }

    // プラン詳細ポップアップ
    const handlePlanDetail = (facility, planShohin, plan) => {
        let popupData = {
            honkanShisetsuCd: facility.honkanShisetsuCd,
            shisetsuCd: facility.shisetsuCd,
            shisetsuName: facility.shisetsuName,
            shisetsuImage: facility.shisetsuImage,
            generalFlg: facility.generalFlg,
            planShohinCd: planShohin.planShohinCd,
            planShohinName: planShohin.planShohinName,
            planCd: plan.planCd,
            planName: plan.planName,
            machiFlg: plan.machiFlg,
            machiFlgA: plan.machiFlgA,
            machiFlgC: plan.machiFlgC,
            machiFlgE: plan.machiFlgE,
            machiFlgS: plan.machiFlgS,
            planDescription: plan.planDescription,
            dinnerTsukiPlanFlg: plan.dinnerTsukiPlanFlg,
            breakfastTsukiPlanFlg: plan.breakfastTsukiPlanFlg,
            planRyokinTotal: plan.planRyokinTotal,
            planRyokinAdult: plan.planRyokinAdult,
            planRyokinChild: plan.planRyokinChild,
            thanksFlg: plan.thanksFlg,
            planTokuten: plan.planTokuten,
            planAnnaiUrl: plan.planAnnaiUrl,
            roomDescription: plan.roomDescription,
            teikyoStartDate: plan.courseTeikyoStartDate,
            teikyoEndDate: plan.courseTeikyoEndDate,
            menuName: plan.menuName,
            courseGazoURL: plan.courseGazoURL,
            courseNaiyoSetsumeibun1: plan.courseNaiyoSetsumeibun1,
            courseNaiyoSetsumeibun2: plan.courseNaiyoSetsumeibun2,
            changeType: 'plan'
        }
        setPopupData("プラン詳細", "planDetail", popupData);
    }

    // 「予約する」ボタン押下
    const handleReserve = (facility, planShohin, plan) => {
        setMembershipReserveInfo({
            ...membershipReserveInfo,
            honkanShisetsuCd: facility.honkanShisetsuCd,
            shisetsuCd: facility.shisetsuCd,
            shisetsuName: facility.shisetsuName,
            generalFlg: facility.generalFlg,
            planShohinCd: planShohin.planShohinCd,
            planCd: plan.planCd,
            planCategoryDetailCd: plan.planCategoryDetailCd,
            planName: plan.planName,
            machiFlg: plan.machiFlg,
            dinnerTsukiPlanFlg: plan.dinnerTsukiPlanFlg,
            breakfastTsukiPlanFlg: plan.breakfastTsukiPlanFlg,
            planRyokinTotal: plan.planRyokinTotal,
            planRyokinAdult: plan.planRyokinAdult,
            planRyokinChild: plan.planRyokinChild,
            thanksFlg: plan.thanksFlg,
            planTokuten: plan.planTokuten,
            planAnnaiUrl: plan.planAnnaiUrl,
            changeFlg: true,
            changeType: 'plan',
            yoyakuNo: membershipReserveComf.yoyakuNo,
        });
        const selectedRoom = room.find(r => r.selected);
        const roomCnt = selectedRoom ? Number(selectedRoom.id) : 1;
        const inputUserInfo = getInputUserInfo();
        const inputRooms = sliceMembershipReserveComfRoomList(roomCnt);
        
        setInputUserInfo({
            ...inputUserInfo,
            inputRoomList: inputRooms.map((r) => {
                return {
                    ...r,
                    roomTypeName: r.hyjRmType,
                };
            }),
        });
        history.push("/reserve/hotel/inputUser");
    }

    // 施設画像エラー時処理
    const handleErrorFacility = (index) => {
        let newFacilityList = [];
        facilityList.forEach((facility, facilityIndex) => {
            if (facilityIndex != index) {
                newFacilityList.push(facility);
            }
        })
        calcPlanNum(newFacilityList);
        setFacilityList(newFacilityList);
    }

    // プラン画像エラー時処理
    const handleErrorPlan = (shisetsuCd, planCd) => {
        let newFacilityList = [];
        facilityList.forEach(facility => {
            if (facility.shisetsuCd == shisetsuCd) {
                let newPlanList = [];
                facility.planList.forEach((plan) => {
                    if (plan.planCd != planCd) {
                        newPlanList.push(plan);
                    }
                });
                facility.planList = newPlanList;
            }
            newFacilityList.push(facility);
        });
        calcPlanNum(newFacilityList);
        setFacilityList(newFacilityList);
    }

    // 料金表示
    const handleOpenFee = (facilityIndex, planIndex) => {
        facilityList[facilityIndex]["planShohinList"][planIndex]["openFlg"] = !facilityList[facilityIndex]["planShohinList"][planIndex]["openFlg"];
        let newFacilityList = [];
        facilityList.forEach(value => {
            newFacilityList.push(value);
        });
        setFacilityList(newFacilityList);
    }

    // 該当プラン件数計算
    const calcPlanNum = (list) => {
        let count = 0;
        if (list) {
            list.forEach((facility) => {
                if (facility.planList) {
                    facility.planList.forEach((plan) => {
                        count++;
                    })
                }
            })
        }
        setPlanNum(count);
    }

     // プラン件数計算
     const getPlanShohinCount = (planShohinList) => {
        let planShohinCount = planShohinList?.length;
        planShohinList?.forEach(planShohin => {
            if (planShohin.planList?.[0]?.machiFlg != "0") {
                planShohinCount--;
            }
        });
        return  planShohinCount;
    }

    const getPlanName = (membershipReserveComf) => {
        // 予約するときに素泊まりはplanCdを連携しない仕様なので取得できない
        return membershipReserveComf.planCd ? membershipReserveComf.planName : "";
    }

    const getInputUserInfo = () => {
        let inputAdultSum = 0;
        let menSum = 0;
        let womenSum = 0;
        let childSum = 0;
        let preschoolerSum = 0;
        let babySum = 0;
        membershipReserveComf.roomList.forEach(roomObj => {
            menSum += Number(roomObj.menCnt);
            womenSum += Number(roomObj.womenCnt)
            childSum += Number(roomObj.childCnt)
            preschoolerSum += Number(roomObj.preschoolerCnt)
            babySum += Number(roomObj.babyCnt)
        })
        inputAdultSum = menSum + womenSum;
        const ret = {
            adultCnt: inputAdultSum,
            childCnt: childSum,
            preschoolerCnt: preschoolerSum,
            babyCnt: babySum,
            inputRoomList: membershipReserveComf.roomList.map(r => { return { ...r, roomTypeName: r.hyjRmType } }),
            foodList: membershipReserveComf.foodList ? membershipReserveComf.foodList : [],
            allergyKbn: membershipReserveComf.allergyKbn,
            allergyBiko: membershipReserveComf.allergyBiko,
            foodRequest: membershipReserveComf.foodRequest,
            daihyouName: membershipReserveComf.daihyouName,
            daihyouNameKana: membershipReserveComf.daihyouNameKana,
            mainPhoneKbn: membershipReserveComf.mainPhoneKbn,
            mainPhoneNumber: membershipReserveComf.mainPhoneNumber,
            contactPhoneNumber: membershipReserveComf.contactPhoneNumber,
            contactMailAddress: membershipReserveComf.contactMailAddress,
            relationCd: membershipReserveComf.relationCd,
            prefectureCd: membershipReserveComf.prefectureCd,
            transportCd: membershipReserveComf.transportCd,
            carCnt: membershipReserveComf.carCnt,
            busTime: membershipReserveComf.busTime,
            kozafurikaeFlg: membershipReserveComf.kozafurikaeFlg,
            smartCheckInFlg: membershipReserveComf.smartCheckInFlg,
            smartCheckOutFlg: membershipReserveComf.smartCheckOutFlg,
            nonstopCheckInFlg: membershipReserveComf.nonstopCheckInFlg,
            biko: membershipReserveComf.biko,
            kakuninMailKiboKbn: membershipReserveComf.kakuninMailKiboKbn,
            confirmReserveMail: membershipReserveComf.kakuninMailKiboKbn ? membershipReserveComf.kakuninMailAddress : "",
            applicantFlg: membershipReserveComf.applicantFlg
        };
        return ret;
    }

    // プランを変更せずに進むボタン
    const onClickTimeChange = () => {
        // 変更可能チェック
        // 予約内容取得処理
        setMembershipReserveInfo({
            ...membershipReserveInfo,
            honkanShisetsuCd: membershipReserveComf.honkanShisetsuCd,
            planShohinCd: membershipReserveComf.planShohinCd,
            shisetsuName: membershipReserveComf.shisetsuName,
            shisetsuCd: membershipReserveComf.shisetsuCd,
            yoyakuNo: membershipReserveComf.yoyakuNo,
            planCd: membershipReserveComf.planCd,
            planCategoryDetailCd: membershipReserveComf.planCategoryDetailCd,
            machiFlg: membershipReserveComf.machiFlg,
            planName: getPlanName(membershipReserveComf),
            dinnerTsukiPlanFlg: membershipReserveComf.dinnerTsukiPlanFlg,
            breakfastTsukiPlanFlg: membershipReserveComf.breakfastTsukiPlanFlg,
            planRyokinTotal: membershipReserveComf.totalRoomPrice,
            thanksFlg: membershipReserveComf.thanksFlg,
            assignFlg: membershipReserveComf.assignFlg,
            changeFlg: true,
            changeType: 'member'
        })
        let adultSum = 0;
        let childSum = 0;
        membershipReserveComf.roomList.forEach(room => {
            adultSum += room.menCnt + room.womenCnt;
            childSum += room.childCnt + room.preschoolerCnt + room.babyCnt;
        })
        let kaiinkenCd = "";
        let kaiinkenNo = "";
        login.memberInfo?.forEach(info => {
            info.memberList?.data.kaiinInfoList.forEach((value, index) => {
                if (membershipSearchParam.keiyakuNo == value.keiyakuNo) {
                    kaiinkenCd = value.ownerCd;
                    kaiinkenNo = value.ownerNo;
                }
            })
        })
        if (loginType === "CRAWL") {
            kaiinkenCd = membershipReserveComf.ownerCd || "";
            kaiinkenNo = membershipReserveComf.ownerNo || "";
        }

        // チェックアウト
        const endDate = dateList.find(d => d.selected)?.id ?? '';
        // 室数
        const selectedRoom = room.find(r => r.selected);
        const roomCnt = selectedRoom ? Number(selectedRoom.id) : 1;
        setMembershipSearchParam({
            checkInDate: membershipReserveComf.checkInDate,
            checkOutDate: endDate,
            nights: commonUtil.getNights(membershipReserveComf.checkInDate, endDate, "-"),
            adultCnt: adultSum,
            childCnt: childSum,
            roomCnt: roomCnt,
            keiyakuNo: membershipSearchParam.keiyakuNo,
            riyoKaiinkenSyubetCd: membershipSearchParam.riyoKaiinkenSyubetCd,
            kaiinkenCd: kaiinkenCd,
            kaiinkenNo: kaiinkenNo,
            memberCd: resvKaiinken.length? resvKaiinken[0].memberCd : "",
        });
        const inputUserInfo = getInputUserInfo();
        const inputRooms = sliceMembershipReserveComfRoomList(roomCnt);
        setInputUserInfo({
            ...inputUserInfo,
            inputRoomList: inputRooms.map((r) => {
                return {
                    ...r,
                    roomTypeName: r.hyjRmType,
                };
            }),
        });
        if (membershipReserveComf.shokaKenriList) {
            let rightlist = [];
            membershipReserveComf.shokaKenriList.forEach(value => {
                rightlist.push({
                    stayDate: value.riyoDate,
                    stayKenriIroKbn: value.shokaKenriIro,
                    stayKenriList: value.shokaList.map(shokaDate => {
                        return { shokaKenriIroKbn: shokaDate.shokaKenriIro, shokaKenriDate: shokaDate.shokaDate }
                    })
                })
            })
            setRight(rightlist)
        }
        //画面遷移
        history.push("/reserve/hotel/inputUser");
    }

    return (
        <div style={style.top}>
            <BreadCrumb
                breadCrumbStyle={isWideTablet ? { display: "none" } : style.breadCrumb}
                linkStyle={style.link}
                linkList={linkList}
                lastLabel="プラン変更"
                lastLabelClassName="lastLabel"
            />
            <div style={isMobilePhone ? style.wrapperMobile : style.wrapper}>
                <div id="condition" style={displaySwitch ? { display: "none" } : { display: "block" }}>
                    <div style={isMobilePhone ? style.searchboxMobile : style.searchbox}>
                        <div style={errorInfo.errorFlg ? style.errorDiv : { display: "none" }}>
                            <ErrorMassage style={style.errorMassage} data={errorInfo.errorMessage} />
                        </div>
                        <ConditionChangeArea
                            style={style}
                            isMobilePhone={isMobilePhone}
                            onClickOpenCalendarWindow={onClickOpenCalendarWindow}
                            onClickOpenCheckListWindow={onClickOpenCheckListWindow}
                            displaySwitch={displaySwitch}
                            errFlgList={errFlgList}
                            kaiinkenInfo={kaiinkenInfo}
                            dateList={dateList}
                            setDateList={setDateList}
                            generalFlg={membershipReserveInfo.generalFlg}
                        />
                    </div>
                    <div style={isMobilePhone ? style.searchboxMobile : style.searchbox}>
                        <Button buttonText="検 索" className={isMobilePhone ? "searchBtnStyleSp" : "searchBtnStylePcChange"} onClick={onClickSearch} />
                    </div>
                    <div style={isMobilePhone ? style.searchboxMobile : style.searchbox}>
                        <Button buttonText="プランを変更せずに進む" className={isMobilePhone ? "noChangeBtnStyleSp" : "noChangeBtnStylePc"} onClick={onClickTimeChange} />
                    </div>
                </div>
                <div className="planListInnerWrapper" style={{ textAlign: "left" }}>
                    <PlanList
                        facilityList={facilityList}
                        facilityListWrapperName={"hiddenItem"}
                        planListWrapperName={"changePlanListWrap"}
                        planWrapperName={"planWrapper"}
                        planListStyle={style.planList}
                        facilityImgStyle={style.facilityImg}
                        handlePlanDetail={handlePlanDetail}
                        handleReserve={handleReserve}
                        handleErrorFacility={handleErrorFacility}
                        handleErrorPlan={handleErrorPlan}
                        handleOpenFee={handleOpenFee}
                        getPlanShohinCount={getPlanShohinCount}
                        isWideTablet={isWideTablet}
                        changePlanFlg={true}
                    />
                </div>
            </div>
        </div>
    );
};

const style = {
    top: {
        //paddingBottom: "50px",
    },

    wrapper: {
        backgroundColor: "rgba(255, 255, 255, 0.9)",
        textAlign: "center",
        width: "70%",
        margin: "50px auto",
        paddingBottom: "50px",
        fontSize: "80%",
    },
    wrapperMobile: {
        backgroundColor: "rgba(255, 255, 255, 0.9)",
        textAlign: "center",
        width: "90%",
        margin: "auto",
        marginTop: "40px",
        padding: "20px 10px",
        fontSize: "90%",
    },
    container: {
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-between",
    },
    breadCrumb: {
        display: "flex",
        color: "white",
        margin: "8px auto 20px auto",
        width: "60%",
    },
    link: {
        display: "inline-block",
        padding: "3px",
        color: "white",
        fontSize: "small",
    },
    searchbox: {
        width: "70%",
        margin: "0px auto",
        paddingTop: "60px",
    },
    searchboxMobile: {
        width: "90%",
        margin: "0px auto",
        paddingTop: "20px",
    },
    planList: {
        width: "100%",
    },
    facilityImg: {
        display: "none",
    },
    errorMassage: {
        display: "inline-block",
        whiteSpace: "pre-line",
        textAlign: "center",
        padding: "15px 0px 0px 0px",
    },
    errorDiv: {
        display: "block",
        color: "red",
        textAlign: "center",
        fontSize: "0.8rem",
        background: "rgba(255,255,255,0)",
        border: 0,
        fontWeight: "bold"
    },
};

const mapStateToProps = (state) => {
    return {
        checkIn: state.checkIn,
        checkOut: state.checkOut,
        facility: state.facility,
        login: state.login,
        room: state.room,
        adultNum: state.adultNum,
        childNum: state.childNum,
        planConditions: state.planConditions,
        grade: state.grade,
        food: state.food,
        privilegedService: state.privilegedService,
        membershipFacility: state.membershipFacility,
        membershipSearchParam: state.membershipSearchParam,
        membershipReserveInfo: state.membershipReserveInfo,
        membershipReserveComf: state.membershipReserveComf,
        resvKaiinken: state.resvKaiinken,
        inputUserInfo: state.inputUserInfo
    };
};

const mapToDispatchToProps = (dispatch) => {
    return {
        setDispDetailCondition: (item) => {
            dispatch({ type: "DISP_DETAIL_CONDITION", payload: { dispDetailCondition: item } })
        },
        setRoom: (item) => {
            dispatch({ type: "ROOM", payload: { room: item } })
        },
        setAdultNum: (item) => {
            dispatch({ type: "ADULT_NUM", payload: { adultNum: item } })
        },
        setChildNum: (item) => {
            dispatch({ type: "CHILD_NUM", payload: { childNum: item } })
        },
        setPlanConditions: (item) => {
            dispatch({ type: "PLAN_CONDITIONS", payload: { planConditions: item } })
        },
        setGrade: (item) => {
            dispatch({ type: "GRADE", payload: { grade: item } })
        },
        setFood: (item) => {
            dispatch({ type: "FOOD", payload: { food: item } })
        },
        setPrivilegedService: (item) => {
            dispatch({ type: "PRIVILEGED_SERVICE", payload: { privilegedService: item } })
        },
        setMembershipReserveInfo: (item) => {
            dispatch({ type: "MEMBERSHIP_RESERVE_INFO", payload: { membershipReserveInfo: item } })
        },
        setMembershipSearchParam: (item) => {
            dispatch({ type: "MEMBERSHIP_SEARCH_PARAM", payload: { membershipSearchParam: item } })
        },
        setMembershipResvStartDate: (item) => {
            dispatch({ type: "MEMBERSHIP_RESV_START_DATE", payload: { membershipResvStartDate: item } })
        },
        setInputUserInfo: (item) => {
            dispatch({ type: "INPUT_USER_INFO", payload: { inputUserInfo: item } })
        },
        setRight: (item) => {
            dispatch({ type: "RIGHT", payload: { right: item } })
        },
    };
}

export default connect(mapStateToProps, mapToDispatchToProps)(MembershipChangePlanContainer);
